import React, { FC, PropsWithChildren } from 'react';

import { GreenhouseJson } from 'generated/drupal-graphql';

interface JobPostingStructuredDataProps {
  job: GreenhouseJson;
}

const JobPostingStructuredData: FC<PropsWithChildren<JobPostingStructuredDataProps>> = ({ job }) => {
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'JobPosting',
    description: job.description,
    employmentType: job.employmentType,
    industry: 'Computer Software',
    jobLocation: {
      '@type': 'Place',
    },
    hiringOrganization: {
      '@type': 'Organization',
      name: 'Lucid',
      sameAs: 'https://lucid.co',
      logo: 'https://d2slcw3kip6qmk.cloudfront.net/marketing/pages/golucid/logos/lucid-square-logo@2x.png',
    },
    salaryCurrency: 'USD',
    title: job.title,
    identifier: job.id,
  };
  return (
    <script
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      id="job-posting-structure-data"
      type="application/ld+json"
    />
  );
};

export default JobPostingStructuredData;
